/**
 * Define dynamic link mixin
 *
 * @author minkyoung.park@emcast.com
 */

import loginApi from '@/api/loginApi.js'
import i18nApi from '@/api/i18nApi.js'
import { setUserLanguage } from '@/translations/i18nSetup'

export const dynamicMixin = {
    methods: {
        // 브랜드 정보 기본 설정(set brand information)
        setBrandInfo() {
            return new Promise(resolve => {                
                let params = {
                    brandCode: this.$route.params.brandCode
                }

                i18nApi.guestBrand(params).then((response) => {
                    let responseBrand = response.data.data

                    window.BRAND_CODE = responseBrand.code
                    window.BRAND_NAME = responseBrand.name
                    window.BRAND_LOGO = responseBrand.logo
                    window.BRAND_COMPANY = responseBrand.companyName
                    
                    localStorage.setItem('brandCode', responseBrand.code)
                    localStorage.setItem('brandName', responseBrand.name)
                    localStorage.setItem('brandLogo', responseBrand.logo)
                    localStorage.setItem('brandCompany', responseBrand.companyName)
                    
                    setUserLanguage().then(() => {
                        resolve()
                    })
                }).catch((err) => {
                    
                })
            })
        },

        checkLogin() {
            return new Promise((resolve, reject) => {
                if (localStorage.getItem('token')) {
                    // 로그인 토큰 유효성 체크(check auth token)
                    loginApi.validToken().then((response) => {
                        resolve()
                    }).catch((err) => {
                        localStorage.removeItem('token')
                        reject()
                    })
                } else {
                    reject()
                }
            })
        }

    }
}